export class Navegacion {
     public seccion = 0 ;
}